import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function ticketClass(state=initialState.ticketClass, action) {
    switch (action.type) {
        case commonConstants.GET_TICKET_CLASS:
            return Object.assign({}, state, action.ticketClass);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/ticketClass.reducer.js